module.exports = __webpack_public_path__ + "teqbahn-assets/media/coronaimage2.bac7a06f.png";